export default "__VITE_ASSET__1b016e56__"